import type { HTMLAttributes } from 'react'
import { cn } from '@/shared/lib'

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'accent'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
}

// Статус читается цветом текста на pill-рамке (mono-caps) — заливок канон
// избегает, красный — дефицит: только danger. accent (роль «админ») — info-синий.
const byTone: Record<BadgeTone, string> = {
  neutral: 'border-border-default text-text-secondary',
  success: 'border-border-default text-success',
  warning: 'border-border-default text-warning',
  danger: 'border-border-accent text-accent',
  accent: 'border-border-default text-info',
}

export function Badge({ tone = 'neutral', className, children, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-pill border px-2.5 py-1 font-mono text-xs uppercase tracking-wide',
        byTone[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  )
}
